import TruncateMarkup from "react-truncate-markup";
import styles from "./TruncatedDescription.module.scss";
import clsx from "clsx";
import { ManageAsset } from "../../api/decimal/common-types/manageAssets.ts";
import { UnsafeHtml } from "../../core-ui/UnsafeHtml.tsx";
import { ComponentPropsWithoutRef } from "react";

export default function TruncatedDescription({
  className,
  asset,
  color,
}: {
  className?: string;
  asset: ManageAsset | VST.Bridge.Asset;
  color?: ComponentPropsWithoutRef<typeof UnsafeHtml>["color"];
}) {
  if (!asset.description) {
    return null;
  }

  return (
    // a11y: css not appropriate for long truncations, as visible text
    // must closely match the text read by the screen reader
    <div className={clsx(styles.description, className)}>
      <TruncateMarkup lines={4}>
        <UnsafeHtml purifyOpts={{ FORBID_TAGS: ["p"] }} color={color}>
          {asset.description}
        </UnsafeHtml>
      </TruncateMarkup>
    </div>
  );
}
